import { authFetch } from "../utils/api"; 

export const saveRecurrence = async (finalData) => {
    const isCreating = !finalData.id;
    const dataToSend = { ...finalData };

    if (dataToSend.initialMonthsCycle && !dataToSend.initial_months_cycle) {
        dataToSend.initial_months_cycle = JSON.stringify(dataToSend.initialMonthsCycle);
    } else if (typeof dataToSend.initial_months_cycle === 'object') {
        dataToSend.initial_months_cycle = JSON.stringify(dataToSend.initial_months_cycle);
    }

    const payload = {
        type: dataToSend.type,
        day: Number(dataToSend.day),
        montant: Number(dataToSend.montant),
        categorie_id: Number(dataToSend.categorie_id),
        description: dataToSend.description,
        statut: dataToSend.statut || "Payé",
        paiementMode: dataToSend.paiementMode,
        sourceAccountId: dataToSend.sourceAccountId ? Number(dataToSend.sourceAccountId) : null,
        destinationAccountId: dataToSend.destinationAccountId ? Number(dataToSend.destinationAccountId) : null,
        person_id: dataToSend.person_id ? Number(dataToSend.person_id) : null,
        account_id: dataToSend.account_id ? Number(dataToSend.account_id) : null,
        is_active: dataToSend.is_active,
        startDate: dataToSend.startDate,
        recurrenceMonths: dataToSend.recurrenceMonths || [],
        payerPersonId: dataToSend.payerPersonId ? Number(dataToSend.payerPersonId) : null,
        beneficiaryPersonId: dataToSend.beneficiaryPersonId ? Number(dataToSend.beneficiaryPersonId) : null,
    };

    try {
        const urlPath = isCreating ? '/recurrences' : `/recurrences/${finalData.id}`;
        const method = isCreating ? 'post' : 'put';
        const response = await authFetch[method](urlPath, payload);

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Erreur API (${response.status}): ${errorText}`);
        }
        return await response.json();
    } catch (error) {
        console.error("❌ Erreur dans saveRecurrence:", error);
        throw error;
    }
};

export const processRecurrences = async () => {
    try {
        const response = await authFetch.post('/process-recurrences', {});
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ error: response.statusText }));
            throw new Error(errorData.error || "Échec du traitement des récurrences.");
        }
        return await response.json();
    } catch (error) {
        console.error("❌ Erreur dans processRecurrences service:", error);
        throw error;
    }
};